<div class="award-letter-shell" [class.pdf-export-active]="isPdfExporting">
  <div class="award-toolbar">
    <h5 class="award-toolbar-title">Eligibility Calculator</h5>

    <div class="award-toolbar-actions">
      <button class="award-action-button award-action-button-primary" type="button" (click)="downloadPdf()">Download PDF</button>
      <button class="award-action-button award-action-button-secondary" type="button" (click)="printletter()">Print</button>
      <button class="award-action-button award-action-button-secondary" type="button" (click)="onClickBack()">
        <i class="fa fa-arrow-left" title="Go Back"></i>&nbsp;Back
      </button>
    </div>
  </div>

  <div class="award-letter-wrapper">
    <kendo-pdf-export
      #pdfExport
      paperSize="Letter"
      [margin]="{ top: '0.25in', bottom: '0.25in', left: '0.3in', right: '0.3in' }"
      [scale]="0.95"
      [repeatHeaders]="true">
      <div class="award-letter-document">
        <section class="award-page award-page-first">
          <header class="letter-header">
            <div class="letter-heading-title">GEORGIA DEPARTMENT OF EDUCATION</div>
            <div class="letter-heading-subtitle">Special Needs Scholarship Program</div>
            <div class="letter-heading-address">
              <span class="letter-heading-part">205 Jesse Hill Jr. Dr. SE</span>
              <span class="letter-heading-part">2053 Twin Towers East</span>
              <span class="letter-heading-part">Atlanta, Georgia 30334</span>
            </div>
          </header>

          <div class="letter-rule"></div>

          <div class="letter-meta-grid">
            <div class="letter-meta-item"><strong>Date:</strong> {{ today | date: 'MM/dd/yyyy' }}</div>
            <div class="letter-meta-item letter-meta-right"><strong>School Year:</strong> {{ formattedSchoolYear }}</div>
          </div>

          <div class="letter-subject-box">
            <strong>RE: Special Needs Scholarship Eligibility Determination</strong>
          </div>

          <p class="letter-greeting">Dear Parent/Guardian:</p>

          <p class="letter-body-text">
            The Georgia Department of Education has reviewed the information provided for the student listed below.
            Based on the data available for the {{ continuationSchoolYearText }} school year, the student has been
            determined eligible for participation in the Georgia Special Needs Scholarship Program.
          </p>

          <section class="letter-section">
            <div class="letter-section-title">Student Information</div>

            <table class="letter-table student-table">
              <tbody>
                <tr>
                  <th>Student Name</th>
                  <td>{{ studentName }}</td>
                </tr>
                <tr>
                  <th>Date of Birth</th>
                  <td>{{ calSearch.birthDate | date: 'MMMM d, y' }}</td>
                </tr>
                <tr>
                  <th>GTID</th>
                  <td>{{ calSearch.gtid }}</td>
                </tr>
                <tr>
                  <th>Last Public School System</th>
                  <td>{{ calSearch.systemName }}</td>
                </tr>
                <tr>
                  <th>Last Public School Attended</th>
                  <td>{{ calSearch.schoolName }}</td>
                </tr>
              </tbody>
            </table>
          </section>

          <section class="letter-section">
            <div class="letter-section-title">Scholarship Award Information</div>

            <table class="letter-table amount-table">
              <thead>
                <tr>
                  <th>Description</th>
                  <th class="amount-column">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Base Scholarship Amount</td>
                  <td class="amount-column">{{ calSearch.qbeAmount | currency }}</td>
                </tr>
                <tr>
                  <td>{{ legislativeFormulaLabel }}</td>
                  <td class="amount-column">{{ legislativeFormulaAdjustment | currency }}</td>
                </tr>
                <tr class="amount-total-row">
                  <td>Total Scholarship Amount Awarded</td>
                  <td class="amount-column">{{ calSearch.displayAmount | currency }}</td>
                </tr>
              </tbody>
            </table>
          </section>

          <div class="note-callout note-callout-split">
            <p>
              {{ noteIntroText }} {{ noteContinuationText }}
            </p>
          </div>

          <footer class="letter-footer">
            Georgia Department of Education <span class="letter-footer-separator" aria-hidden="true"></span> Special Needs Scholarship Program
          </footer>
        </section>

        <section class="award-page award-page-payment page-break">
          <header class="letter-header letter-header-secondary">
            <div class="letter-heading-title">GEORGIA DEPARTMENT OF EDUCATION</div>
            <div class="letter-heading-subtitle">Special Needs Scholarship Program</div>
            <div class="letter-heading-tertiary">Scholarship Award and Payment Information</div>
          </header>

          <div class="letter-rule"></div>

          <div class="note-callout note-callout-emphasis">
            <p>
              <strong class="letter-emphasis-underline letter-emphasis-note">PLEASE NOTE</strong>:&nbsp;The scholarship award is based on annual budgetary appropriations by the
              General Assembly. Should there be a midterm reduction to the state budget by the Georgia General
              Assembly, scholarship award amounts would be reduced proportionately.
              <strong>
                If such budgetary adjustments are made, the reduction in a student's total scholarship award would be
                made in the 4th quarter payment. Parents would receive communication from the Department of Education
                should this situation occur.
              </strong>
            </p>
          </div>

          <p class="letter-body-text">{{ paymentScheduleText }}</p>
          <p class="letter-body-text">
            As required by law, each quarterly scholarship payment is issued via paper check made payable to the
            student's parent and mailed by the Department to the student's participating private school. The parent
            <strong class="letter-emphasis-underline">must</strong> restrictively ("for deposit only") endorse the check to
            the participating school for deposit into the school's account.
          </p>
          <p class="letter-body-text">{{ enrollmentText }}</p>
          <p class="letter-body-text">{{ expenseText }}</p>

          <section class="letter-section">
            <div class="letter-section-title">Next Steps</div>
            <p class="letter-body-text">
              Please print this letter and provide it to the approved participating private school of your choice.
              The private school will assist you in completing any additional required enrollment documentation.
              Participation in the program is contingent upon compliance with all program requirements.
            </p>
          </section>

          <div class="contact-box contact-box-inline">Contact {{ scholarshipContactEmail }} with questions.</div>
          <footer class="letter-footer">
            Georgia Department of Education <span class="letter-footer-separator" aria-hidden="true"></span> Special Needs Scholarship Program
          </footer>
        </section>
      </div>
    </kendo-pdf-export>
  </div>
</div>
